import ValidatorForm from "./ValidatorForm";

const ValidatorModal = ({
  show,
  onClose,
  managerAccounts,
  validationTypes,
  domainId,
  validatorToEdit,
  isSubmitting,
  onSubmit,
}) => {
  const isEditing = !!validatorToEdit;

  return (
    <div
      className={`modal fade ${show ? "show d-block" : ""}`}
      tabIndex="-1"
      aria-hidden={!show}
      style={{ backgroundColor: show ? "rgba(0,0,0,0.5)" : "transparent" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header text-white">
            <h5 className="modal-title">{isEditing ? "Modifier Validateur" : "Nouveau Validateur"}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>

          <ValidatorForm
            managerAccounts={managerAccounts}
            validationTypes={validationTypes}
            domainId={domainId}
            validatorToEdit={validatorToEdit}
            isSubmitting={isSubmitting}
            onSubmit={onSubmit}
            onCancel={onClose}
          />
        </div>
      </div>
    </div>
  );
};

export default ValidatorModal;
